/* eslint-disable no-lonely-if */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
  tableCellClasses,
  Paper,
  Grid,
  Stack,
  styled,
  MenuItem,
  Chip,
  Autocomplete,
  FormControlLabel,
  Checkbox,
  AccordionSummary,
  AccordionDetails,
  IconButton,
  Accordion,
  Collapse,
  Dialog,
  DialogTitle,
  DialogContent,
  useMediaQuery,
  Divider,
  Box,
} from '@mui/material';
import moment from 'moment';
import { saveAs } from 'file-saver';
import numeral from 'numeral';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import EditNoteIcon from '@mui/icons-material/EditNote';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import { Email, Phone } from '@mui/icons-material';
import PortraitIcon from '@mui/icons-material/Portrait';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Container } from 'reactstrap';
import VerifiedIcon from '@mui/icons-material/Verified';
import { useTheme } from '@emotion/react';
import PreviewIcon from '@mui/icons-material/Preview';
import EventRepeatIcon from '@mui/icons-material/EventRepeat';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import axios from '../../../utils/axios';
import UIContext from '../../../context/UIContext';
import PreviewForCourierOrderApproval from './PreviewForCourierOrderApproval';
import PreviewForCargoOrderApproval from './PreviewForCargoOrderApproval';
import NoResultsFound from '../../../components/NoResultsFound';
import ComplaintAdd from '../Common/ComplaintAdd';

const StyledTableCell = styled(TableCell)({
  color: 'white',
  fontWeight: '600',
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#257180',
  },
  whiteSpace: 'nowrap',
});

const StyledTableCell2 = styled(TableCell)({
  color: 'white',
  fontWeight: '600',
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#8EB486',
  },
  whiteSpace: 'nowrap',
});

const approvalStatusOptions = [
  { label: 'All', value: 'All' },
  { label: 'Pending', value: 'Pending' },
  { label: 'Approved', value: 'Approved' },
  { label: 'Cancelled', value: 'Cancelled' },
  { label: 'Cancelled Request', value: 'Cancelled Request' },
  { label: 'Booking Confirmed', value: 'Booking Confirmed' },
  { label: 'Bill Raised', value: 'Bill Raised' },
  { label: 'Payment Received', value: 'Payment Received' },
  { label: 'Part. Payment', value: 'Part. Payment' },
];

const customizedItemsOptions = [
  { label: 'All', value: 'All' },
  { label: 'Yes', value: 'Y' },
  { label: 'No', value: 'N' },
];

const outstandingOptions = [
  { label: 'All', value: 'All' },
  { label: 'Yes', value: 'Yes' },
  { label: 'No', value: 'No' },
];

const typeOptionsIN = [{ label: 'Air-Cargo', value: 'courier' }];

const typeOptionsUK = [
  { label: 'All', value: 'All' },
  { label: 'Air-Cargo', value: 'courier' },
  { label: 'Sea-Cargo', value: 'cargo' },
];

const typeOptionsSL = [{ label: 'Air-Cargo', value: 'courier' }];

const statusTypeOptions = [
  { label: 'All', value: 'All' },
  { label: 'Order Status', value: 'Order' },
  { label: 'Bill Status', value: 'Bill' },
  { label: 'Reciept Status', value: 'Receipt' },
];

const statusOptions = [
  { label: 'All', value: 'All' },
  { label: 'Yes', value: 'Yes' },
  { label: 'No', value: 'No' },
];

const searchByOptions = [
  { label: 'Phone Number', value: 'phonenumber' },
  { label: 'Ledger', value: 'ledger' },
];

const complaintStatusOptions = [
  { label: "All", value: "All" },
  { label: "Complaint Received", value: "Yes" },
  { label: "Complaint Not Received", value: "No" }
];

const BookingApproval = () => {
  const theme = useTheme();
  const smallScreen = useMediaQuery(theme.breakpoints.down('md'));
  // snackbar context
  const { openSnackBar, showLoading, hideLoading } = useContext(UIContext);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [expanded, setExpanded] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [ledgerPhoneFilterData, setLedgerPhoneFilterData] = useState([]);
  const [salesExecutiveFilterData, setSalesExecutiveFilterData] = useState([]);
  // pagination
  const { totalRows, currentPage } = useMemo(() => {
    const totalRows = tableData.length;
    const totalPages = Math.ceil(totalRows / rowsPerPage);
    const currentPage = Math.max(0, Math.min(page, totalPages - 1));
    return { totalRows, currentPage };
  }, [tableData, page, rowsPerPage]);
  const [isDialogOpen, setDialogOpenState] = useState(false);
  const [currentOrderDetails, setCurrentOrderDetails] = useState(null);
  const [rowData, SetRowData] = useState(null);
  const [openFollowUpTable, setOpenFollowUpTable] = useState(null);
  const [oneCustomerFollowUps, setOneCustomerFollowUps] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [dataList, setDataList] = useState([]);
  const [viewDraft, setViewDraft] = useState(false);
  const [filterInputs, setFilterInputs] = useState({
    ledger: '',
    fromDate: moment().startOf('month').format('YYYY-MM-DD'),
    toDate: moment().format('YYYY-MM-DD'),
    approvalStatus: 'All',
    type: 'courier',
    phonenumber: '',
    salesExecutive: '',
    customizedItems: 'All',
    statusType: 'All',
    status: 'All',
    outstanding: 'All',
    // droppedOrder: 'N',
    searchBy: 'phonenumber',
    Branch: '',
    complaintStatus: 'All'
  });
  const [isComplaintDialogOpen, setComplaintDialogOpenState] = useState(false);
  const [complaintDetail, setComplaintDetail] = useState({
    courierCargoId: '',
    shipmentType: '',
    userType: 'Admin',
    complaintId: '',
    bookingOrderId: 0,
    Register: 'N',
  });

  const closeComplaintDialog = () => {
    setComplaintDialogOpenState(false);
  };

  const openComplaintDialog = (data) => {
    setComplaintDetail(prev => ({
      ...prev,
      courierCargoId: data.orderid,
      shipmentType: data.shipment_Type,
      complaintId: data.complaintId,
      bookingOrderId: data.BookOrderId,
      Register: data.Register,
    }));
    setComplaintDialogOpenState(true);
  };

  const GetAllHelpData = async () => {
    try {
      showLoading();
      const [ledgerResponse, salesExecutiveResponse] = await Promise.all([
        axios.get('/master/customer/GetCustomerHelp/4'),
        axios.get('/Approval/LoginApprovalRoute/GetAllSalesExecutive'),
      ]);
      setLedgerPhoneFilterData(ledgerResponse.data);
      setSalesExecutiveFilterData(salesExecutiveResponse.data);
    } catch (e) {
      openSnackBar('Something Went Wrong', 'error');
    }
    hideLoading();
  };

  const GetCountryList = async () => {
    try {
      const res = await axios.post('/signup/GetCountryList');
      setCountryList(res.data);
    } catch (err) {
      console.log(err.message);
    }
  };

  async function GetBranchList(cntry) {
    try {
      const requestData = {
        CompanyId: sessionStorage.getItem('CompanyId'),
      };

      const config = {
        headers: {
          Country: cntry,
        },
      };
      showLoading();
      const response = await axios.post('signup/GetBranchList', requestData, config);
      const data = response.data.filter((i) => i.webBranch === 'Y');
      setBranchList(data);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }

  useEffect(() => {
    GetAllHelpData();
    GetBranchList(sessionStorage.getItem('Origin'));
    GetCountryList();
  }, []);

  const handleFilterInputs = (e) => {
    setFilterInputs({
      ...filterInputs,
      [e.target.name]: e.target.value,
    });
  };
  const handleReviewButtonClick = (order) => {
    setCurrentOrderDetails(order);
    setDialogOpenState(true);
  };

  const closeDialog = () => {
    setDialogOpenState(false);
    setCurrentOrderDetails(null);
  };

  async function getAllData() {
    if (!validateFilters()) {
      return; // If validation fails, stop the request
    }
    try {
      showLoading();
      let sumData = []
      if (filterInputs.type !== 'All') {
        const response = await axios.post(
          `/Transactions/${filterInputs.type}/GetAllOrder`, {
          ledgerId: filterInputs.ledger?.CUSTOMERID || 0,
          fromDate: moment(filterInputs.fromDate).format('YYYYMMDD'),
          toDate: moment(filterInputs.toDate).format('YYYYMMDD'),
          salesExecutiveId: filterInputs.salesExecutive?.salesPersonId || 0,
          approvalStatus: filterInputs.approvalStatus,
          customizedItem: filterInputs.customizedItems,
          status: filterInputs.status,
          statusType: filterInputs.statusType,
          outStanding: filterInputs.outstanding,
          BranchId: filterInputs.Branch?.BranchId || 0,
          senderCountry: filterInputs.senderCountry?.CountryId || 0,
          receiverCountry: filterInputs.receiverCountry?.CountryId || 0,
          complaintStatus: filterInputs.complaintStatus,
          viewdraft: viewDraft ? 'Y' : 'N',
        })
        if (tableData.length === 0 && response.data.length !== 0) setExpanded(false);
        setTableData(response.data);
        sumData = response.data
      } else {
        const [response1, response2] = await Promise.all([
          axios.post(
            `/Transactions/Courier/GetAllOrder`, {
            ledgerId: filterInputs.ledger?.CUSTOMERID || 0,
            fromDate: moment(filterInputs.fromDate).format('YYYYMMDD'),
            toDate: moment(filterInputs.toDate).format('YYYYMMDD'),
            salesExecutiveId: filterInputs.salesExecutive?.salesPersonId || 0,
            approvalStatus: filterInputs.approvalStatus,
            customizedItem: filterInputs.customizedItems,
            status: filterInputs.status,
            statusType: filterInputs.statusType,
            outStanding: filterInputs.outstanding,
            BranchId: filterInputs.Branch?.BranchId || 0,
            senderCountry: filterInputs.senderCountry?.CountryId || 0,
            receiverCountry: filterInputs.receiverCountry?.CountryId || 0,
            complaintStatus: filterInputs.complaintStatus,
            viewdraft: viewDraft ? 'Y' : 'N',
          }),
          axios.post(
            `/Transactions/Cargo/GetAllOrder`, {
            ledgerId: filterInputs.ledger?.CUSTOMERID || 0,
            fromDate: moment(filterInputs.fromDate).format('YYYYMMDD'),
            toDate: moment(filterInputs.toDate).format('YYYYMMDD'),
            salesExecutiveId: filterInputs.salesExecutive?.salesPersonId || 0,
            approvalStatus: filterInputs.approvalStatus,
            customizedItem: filterInputs.customizedItems,
            status: filterInputs.status,
            statusType: filterInputs.statusType,
            outStanding: filterInputs.outstanding,
            BranchId: filterInputs.Branch?.BranchId || 0,
            senderCountry: filterInputs.senderCountry?.CountryId || 0,
            receiverCountry: filterInputs.receiverCountry?.CountryId || 0,
            complaintStatus: filterInputs.complaintStatus,
            viewdraft: viewDraft ? 'Y' : 'N',
          }),
        ]);

        const data = [...response1.data, ...response2.data].sort((a, b) => a.orderDate.localeCompare(b.orderDate));
        if (tableData.length === 0 && data.length !== 0) setExpanded(false);
        setTableData(data);
        sumData = data
      }
      const summaryData = {
        noOfOrders: sumData.length,
        airCargo: sumData.filter(item => item.shipmentType === 'Courier').length,
        seaCargo: sumData.filter(item => item.shipmentType === 'Cargo').length,
        parcelWeight: parseFloat(
          sumData.reduce((sum, item) => sum + (parseFloat(item.gross_weight) || 0), 0).toFixed(2)
        ),
        noOfBoxes: sumData.reduce((sum, item) => sum + (Number(item.NO_OF_BOXES) || 0), 0)
      };

      // Map summary data to existing `dataList` format
      const updatedDataList = [
        { title: "No. of Orders", value: summaryData.noOfOrders, bgColor: "#e0f7fa", textColor: "#006064" },
        { title: "Air Cargo", value: summaryData.airCargo, bgColor: "#ffe0b2", textColor: "#e65100" },
        { title: "Sea Cargo", value: summaryData.seaCargo, bgColor: "#e1bee7", textColor: "#6a1b9a" },
        { title: "Parcel Weight", value: `${summaryData.parcelWeight}kg`, bgColor: "#c8e6c9", textColor: "#1b5e20" },
        { title: "No. of Boxes", value: summaryData.noOfBoxes, bgColor: "#ffccbc", textColor: "#bf360c" }
      ];

      // Update `datalist` state
      setDataList(updatedDataList);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something went wrong! Try again.', 'error');
    }
    hideLoading();
  }

  const GetOrderApprovalExcel = async () => {
    showLoading();
    try {
      const response = await axios.post("/Transactions/ExcelRoute/AdminOrderApprovalExcel", {
        type: filterInputs.type,
        ledgerId: filterInputs.ledger?.CUSTOMERID || 0,
        fromDate: moment(filterInputs.fromDate).format('YYYYMMDD'),
        toDate: moment(filterInputs.toDate).format('YYYYMMDD'),
        salesExecutiveId: filterInputs.salesExecutive?.salesPersonId || 0,
        salesPersonName: filterInputs.salesExecutive?.salesPersonName || '',
        approvalStatus: filterInputs.approvalStatus,
        customizedItem: filterInputs.customizedItems,
        status: filterInputs.status,
        statusType: filterInputs.statusType,
        outStanding: filterInputs.outstanding,
        searchby: filterInputs.searchBy,
        ledger: filterInputs.ledger?.CUSTOMERNAME || '',
        phonenumber: filterInputs.ledger?.Phone || '',
        BranchName: filterInputs.Branch?.BranchName || '',
        BranchId: filterInputs.Branch?.BranchId || 0,
        senderCountry: filterInputs.senderCountry?.CountryId || 0,
        receiverCountry: filterInputs.receiverCountry?.CountryId || 0,
        senderCountryName: filterInputs.senderCountry?.CountryName || 0,
        receiverCountryName: filterInputs.receiverCountry?.CountryName || 0,
        complaintStatus: filterInputs.complaintStatus,
        viewdraft: viewDraft ? 'Y' : 'N',
      },
        { responseType: "blob" }
      )
      const excelBlob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
      });
      saveAs(excelBlob, `Order Approval Panel-${moment(new Date()).format('MMMM Do YYYY, h-mm a')}`);
      setTimeout(() => {
        hideLoading();
      }, 2000);
    } catch (error) {
      if (error.response?.status === 404) {
        openSnackBar('No records found to export.', 'error');
      } else {
        openSnackBar('Something went wrong! Try again.', 'error');
      }
      hideLoading();
    }

  }

  const [formErrors, setFormErrors] = useState({
    fromDate: '',
    toDate: '',
  });

  const validateFilters = () => {
    const errors = {};
    // Validate fromDate: should not be empty
    if (!filterInputs.fromDate) {
      errors.fromDate = 'From date is required';
    } else if (!moment(filterInputs.fromDate, 'YYYY-MM-DD', true).isValid()) {
      errors.fromDate = 'Invalid date format';
    }

    // Validate toDate: should not be empty and be a valid date
    if (!filterInputs.toDate) {
      errors.toDate = 'To date is required';
    } else if (!moment(filterInputs.toDate, 'YYYY-MM-DD', true).isValid()) {
      errors.toDate = 'Invalid date format';
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0; // Return true if no errors
  };

  const handleFollowUpTableToggle = (rowIndex, data) => {
    SetRowData(data);
    GetOneBookingTimeLine(data);
    setOpenFollowUpTable(true);
  };

  async function GetOneBookingTimeLine(rowData) {
    try {
      showLoading();
      const response = await axios.get(
        `/Transactions/Customer_Timeline/GetOneBookingAllTimeLine/${rowData.orderid}/${rowData.shipmentType === 'Courier' ? 'CO' : 'CA'
        }`
      );
      setOneCustomerFollowUps(response.data);
    } catch (e) {
      openSnackBar(e.response?.data || 'Something went wrong! Try again.', 'error');
    }
    hideLoading();
  }

  return (
    <>
      <Container maxWidth={'xl'} sx={{ pt: 2 }} elevation={3}>
        <Grid justifyContent={'space-between'} alignItems={'center'} spacing={2}>
          <Typography
            variant="h5"
            p={1}
            boxShadow={1}
            borderColor="#11235A"
            textAlign={'center'}
            borderRadius={2}
            pl={2}
            color="white"
            sx={{
              // borderRadius: 50,
              background: '#8EACCD',
              boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
            }}
          >
            <Typography variant="h6" color="white" className="font_style1" textAlign={'center'}>
              Order Approval
            </Typography>
          </Typography>
        </Grid>
        <Stack sx={{ border: '1px solid #CDE8E5', borderRadius: 4, my: 2 }}>
          <Accordion
            expanded={expanded}
            onChange={() => {
              setExpanded((expand) => !expand);
            }}
            disableGutters
            sx={{ borderTop: 'none', borderColor: 'black', backgroundColor: 'inherit' }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon style={{ color: '#8EACCD' }} />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              sx={{ borderTop: 'none' }}
            >
              <Stack justifyContent={'start'} direction={'row'} alignItems={'center'} p={0} m={0}>
                <IconButton aria-label="ExpandMoreIcon" color="#8EACCD">
                  <FilterAltIcon style={{ color: '#8EACCD', width: 24, height: 24 }} />
                </IconButton>
                <Typography
                  sx={{
                    color: '#8EACCD',
                    '&.active': {
                      color: 'text.primary',
                      bgcolor: 'action.selected',
                      fontWeight: 'fontWeightBold',
                    },
                  }}
                  variant="h6"
                >
                  Filters
                </Typography>
              </Stack>
            </AccordionSummary>

            <AccordionDetails sx={{ borderTop: 'none', py: 0, pb: 2, pl: 3 }}>
              <Grid container spacing={2} p={1} pt={0} mb={0.5} rowSpacing={2} columnSpacing={1}>
                {/* <Grid item xs={12} sx={{ textAlign: 'end', pt: 0 }}>
                  <FormControlLabel
                    sx={{
                      flexShrink: 0,
                      '& .MuiFormControlLabel-label': { fontSize: '14px' }, // adjust font size as needed
                    }}
                    control={
                      <Checkbox
                        size="small"
                        name="droppedOrder"
                        checked={filterInputs.droppedOrder === 'Y'}
                        onChange={(event) => {
                          const value = event.target.checked ? 'Y' : 'N';
                          setFilterInputs({ ...filterInputs, droppedOrder: value });
                        }}
                        color="primary"
                      />
                    }
                    label="Cancelled Orders"
                  />
                </Grid> */}
                <Grid item md={2} xs={12}>
                  {/* Search by Filter */}
                  <TextField
                    fullWidth
                    select
                    label="Search by"
                    name="searchBy"
                    value={filterInputs.searchBy}
                    onChange={(e) => {
                      setFilterInputs({
                        ...filterInputs,
                        ledger: '',
                        searchBy: e.target.value,
                      });
                    }}
                    variant="outlined"
                    size="small"
                  >
                    {searchByOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item md={4} xs={12}>
                  <Autocomplete
                    key={filterInputs.searchBy}
                    options={ledgerPhoneFilterData}
                    getOptionLabel={(customer) =>
                      filterInputs.searchBy === 'phonenumber' ? customer.Phone : customer.CUSTOMERNAME
                    }
                    renderOption={(props, customer) => (
                      <li {...props} key={customer.CUSTOMERID}>
                        {filterInputs.searchBy === 'phonenumber' ? customer.Phone : customer.CUSTOMERNAME}
                      </li>
                    )}
                    isOptionEqualToValue={(customer) => customer.CUSTOMERID === filterInputs.ledger.CUSTOMERID}
                    value={filterInputs.ledger || null}
                    name="ledger"
                    onChange={(event, value) => {
                      setFilterInputs({
                        ...filterInputs,
                        ledger: value,
                      });
                    }}
                    size="small"
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={filterInputs.searchBy === 'phonenumber' ? 'Phone Number' : 'Ledger'}
                      />
                    )}
                  />
                </Grid>
                <Grid item md={2} xs={12}>
                  {/* From Date */}
                  <TextField
                    fullWidth
                    label="From Date"
                    type="date"
                    name="fromDate"
                    value={filterInputs.fromDate}
                    onChange={handleFilterInputs}
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    size="small"
                    error={!!formErrors.fromDate}
                    helperText={formErrors.fromDate}
                    inputProps={{ max: '9999-12-31' }}
                  />
                </Grid>
                <Grid item md={2} xs={12}>
                  {/* To Date */}
                  <TextField
                    fullWidth
                    label="To Date"
                    type="date"
                    name="toDate"
                    value={filterInputs.toDate}
                    onChange={handleFilterInputs}
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    size="small"
                    error={!!formErrors.toDate}
                    helperText={formErrors.toDate}
                    inputProps={{ max: '9999-12-31' }}
                  />
                </Grid>
                <Grid item md={2} xs={12}>
                  {/* Shipment Type Filter */}
                  <TextField
                    fullWidth
                    select
                    label="Shipment Type"
                    name="type"
                    value={filterInputs.type}
                    onChange={handleFilterInputs}
                    variant="outlined"
                    size="small"
                  >
                    {(sessionStorage.getItem('Origin') === 'IN' ? typeOptionsIN 
                    :sessionStorage.getItem('Origin') === 'UK' ? typeOptionsUK
                   : typeOptionsSL).map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item md={3} xs={12}>
                  {/* Branch */}
                  <Autocomplete
                    options={branchList} // Use branchList as options
                    getOptionLabel={(branch) => branch.BranchName} // Display branch names
                    renderOption={(props, branch) => (
                      <li {...props} key={branch.BranchId}>
                        {branch.BranchName}
                      </li>
                    )}
                    isOptionEqualToValue={(option, value) => option.BranchId === value?.BranchId}
                    value={filterInputs.Branch || null} // Select branch from filterInputs
                    name="Branch"
                    onChange={(event, value) => {
                      setFilterInputs({ ...filterInputs, Branch: value });
                    }}
                    size="small"
                    renderInput={(params) => <TextField {...params} label="Branch" variant="outlined" />}
                  />

                </Grid>
                <Grid item md={2} xs={12}>
                  {/* Customized item Filter */}
                  <TextField
                    fullWidth
                    select
                    label="Customized Items"
                    name="customizedItems"
                    value={filterInputs.customizedItems}
                    onChange={handleFilterInputs}
                    variant="outlined"
                    size="small"
                  >
                    {customizedItemsOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item md={1} xs={12}>
                  {/* Outstanding Filter */}
                  <TextField
                    fullWidth
                    select
                    label="Outstanding"
                    name="outstanding"
                    value={filterInputs.outstanding}
                    onChange={handleFilterInputs}
                    variant="outlined"
                    size="small"
                  >
                    {outstandingOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item md={2} xs={12}>
                  {/* Status Type Filter */}
                  <TextField
                    fullWidth
                    select
                    label="Status Type"
                    name="statusType"
                    value={filterInputs.statusType}
                    onChange={handleFilterInputs}
                    variant="outlined"
                    size="small"
                  >
                    {statusTypeOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item md={1} xs={12}>
                  {/* Status Filter */}
                  <TextField
                    fullWidth
                    select
                    label="Status"
                    name="status"
                    value={filterInputs.status}
                    onChange={handleFilterInputs}
                    variant="outlined"
                    size="small"
                  >
                    {statusOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item md={3} xs={12}>
                  {/* Approval Status Filter */}
                  <TextField
                    fullWidth
                    select
                    label="Approval Status"
                    name="approvalStatus"
                    value={filterInputs.approvalStatus}
                    onChange={handleFilterInputs}
                    variant="outlined"
                    size="small"
                  >
                    {approvalStatusOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item md={3} xs={12}>
                  <Autocomplete
                    options={countryList || []}
                    getOptionLabel={(country) => country.CountryName || ''}
                    renderOption={(props, country) => (
                      <li {...props} key={country.CountryId}>
                        {country.CountryName}
                      </li>
                    )}
                    isOptionEqualToValue={(option, value) => option?.CountryId === value?.CountryId}
                    value={filterInputs.senderCountry || null}
                    name="senderCountry"
                    onChange={(event, value) => {
                      setFilterInputs({ ...filterInputs, senderCountry: value });
                    }}
                    size="small"
                    renderInput={(params) => <TextField {...params} label="Sender Country" />}
                  />
                </Grid>
                <Grid item md={3} xs={12}>
                  <Autocomplete
                    options={countryList || []}
                    getOptionLabel={(country) => country.CountryName || ''}
                    renderOption={(props, country) => (
                      <li {...props} key={country.CountryId}>
                        {country.CountryName}
                      </li>
                    )}
                    isOptionEqualToValue={(option, value) => option?.CountryId === value?.CountryId} // Compare options
                    value={filterInputs.receiverCountry || null}
                    name="receiverCountry"
                    onChange={(event, value) => {
                      setFilterInputs({ ...filterInputs, receiverCountry: value });
                    }}
                    size="small"
                    renderInput={(params) => <TextField {...params} label="Receiver Country" />}
                  />
                </Grid>
                <Grid item md={3} xs={12}>
                  <Autocomplete
                    options={salesExecutiveFilterData}
                    getOptionLabel={(salesPerson) => salesPerson.salesPersonName}
                    renderOption={(props, salesPerson) => (
                      <li {...props} key={salesPerson.salesPersonId}>
                        {salesPerson.salesPersonName}
                      </li>
                    )}
                    isOptionEqualToValue={(salesPerson) =>
                      salesPerson.salesPersonId === filterInputs.salesExecutive.salesPersonId
                    }
                    value={filterInputs.salesExecutive || null}
                    name="salesExecutive"
                    onChange={(event, value) => {
                      setFilterInputs({ ...filterInputs, salesExecutive: value });
                    }}
                    size="small"
                    renderInput={(params) => <TextField {...params} label="Sales Executive" />}
                  />
                </Grid>
                <Grid item md={3} xs={12}>
                  {/* Complaint Status item Filter */}
                  <TextField
                    fullWidth
                    select
                    label="Complaint Status"
                    name="complaintStatus"
                    value={filterInputs.complaintStatus}
                    onChange={handleFilterInputs}
                    variant="outlined"
                    size="small"
                  >
                    {complaintStatusOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid container justifyContent="flex-end" spacing={2} sx={{ mt: 2 }}>
                 <Grid item md={2} xs={6} sx={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
    {/* Draft Mode Switch */}
   <Box sx={{ 
  display: 'flex', 
  alignItems: 'center', 
  gap: 1,
  bgcolor: viewDraft ? '#eff6ff' : '#f8fafc',
  borderRadius: '8px',
  px: 0.75,
  py: 0.75,
  border: `1px solid ${viewDraft ? '#3b82f6' : '#e2e8f0'}`,
  transition: 'all 0.2s ease',
  '&:hover': {
    borderColor: viewDraft ? '#2563eb' : '#cbd5e1',
    boxShadow: viewDraft ? '0 0 0 2px rgba(59, 130, 246, 0.1)' : '0 0 0 2px rgba(203, 213, 225, 0.1)'
  }
}}>
  {/* Custom Switch - Compact */}
  <Box 
    onClick={() => {
      setViewDraft(!viewDraft)
      setTableData([])
    }}
    sx={{ 
      position: 'relative',
      width: 42,
      height: 24,
      borderRadius: '12px',
      bgcolor: viewDraft ? '#3b82f6' : '#94a3b8',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      overflow: 'hidden',
      flexShrink: 0,
      '&:before': {
        content: '""',
        position: 'absolute',
        top: 2,
        left: viewDraft ? 20 : 2,
        width: 20,
        height: 20,
        borderRadius: '50%',
        bgcolor: 'white',
        transition: 'all 0.2s ease',
        boxShadow: '0 1px 2px rgba(0,0,0,0.15)'
      },
      '&:after': {
        content: '""',
        position: 'absolute',
        top: '50%',
        left: viewDraft ? 6 : 24,
        transform: 'translateY(-50%)',
        width: 8,
        height: 8,
        backgroundImage: viewDraft ? 'radial-gradient(circle, #60a5fa 1px, transparent 1px)' : 'radial-gradient(circle, #cbd5e1 1px, transparent 1px)',
        backgroundSize: '3px 3px',
        opacity: 0.5,
        transition: 'all 0.2s ease'
      }
    }}
  />
  
  {/* Label with Icon - Compact */}
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, minWidth: 80 }}>
    <Box sx={{ 
      width: 22,
      height: 22,
      borderRadius: '5px',
      bgcolor: viewDraft ? '#dbeafe' : '#f1f5f9',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      border: `1px solid ${viewDraft ? '#bfdbfe' : '#e2e8f0'}`
    }}>
      {viewDraft ? (
         <span style={{ fontSize: 13, color: '#3b82f6' }}>📝</span>
        // <LocalShippingIcon sx={{ fontSize: 13, color: '#3b82f6' }} />
      ) : (
        <span style={{ fontSize: 13, color: '#64748b' }}>📝</span>
        // <LocalShippingIcon sx={{ fontSize: 13, color: '#64748b' }} />
      )}
    </Box>
    <Box>
      <Typography variant="body2" fontWeight="500" color={viewDraft ? '#1e40af' : '#475569'}>
        {viewDraft ? 'Draft' : 'Draft'}
      </Typography>
    </Box>
  </Box>
</Box>
  </Grid>
                  <Grid item md={1} xs={6} sx={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
                    {/* View Button */}
                    <Button variant="contained" color="primary" onClick={getAllData} fullWidth sx={{ boxShadow: 0 }}>
                      View
                    </Button>
                  </Grid>
                  <Grid item md={1} xs={6} sx={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
                    <Button
                      variant="contained"
                      style={{ color: 'white', backgroundColor: '#118a27' }}
                      onClick={GetOrderApprovalExcel}
                      fullWidth
                    >
                      Excel
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
        </Stack>
        <Collapse in={tableData.length > 0}>
          <Stack>
            <Grid container spacing={2} mb={2}>
              {dataList.map((item, index) => (
                <Grid item xs={index === 4 ? 12 : 6} sm={index === 4 ? 12 : 4} md={2.4} key={index}>
                  <Paper elevation={6} sx={{ bgcolor: item.bgColor, p: 1, flexGrow: 1 }}>
                    <Typography variant="subtitle2" sx={{ color: item.textColor }} textAlign="center">
                      {item.title}
                    </Typography>
                    <Typography variant="h5" sx={{ color: item.textColor }} textAlign="center">
                      {item.value}
                    </Typography>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </Stack>
        </Collapse>
        <Collapse in={tableData.length > 0}>
          <>
            <TableContainer component={Paper} elevation={2} sx={{ bgcolor: 'inherit', maxHeight: 600 }}>
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="center">S.No</StyledTableCell>
                    <StyledTableCell align="left">Order No</StyledTableCell>
                    <StyledTableCell align="left">Order Date</StyledTableCell>
                    <StyledTableCell align="left">Ledger Details</StyledTableCell>
                    <StyledTableCell align="center">Branch</StyledTableCell>
                    <StyledTableCell align="center">Primary SE</StyledTableCell>
                    <StyledTableCell align="center">Secondary SE</StyledTableCell>
                    <StyledTableCell align="center">Shipment Type</StyledTableCell>
                    <StyledTableCell align="center">Sender Country</StyledTableCell>
                    <StyledTableCell align="center">Receiver Counry</StyledTableCell>
                    <StyledTableCell align="center">Parcel Weight</StyledTableCell>
                    <StyledTableCell align="center">No of Boxes</StyledTableCell>
                    <StyledTableCell align="center">Approval Status</StyledTableCell>
                    <StyledTableCell align="center">Order Status</StyledTableCell>
                    <StyledTableCell align="center">Bill Status</StyledTableCell>
                    <StyledTableCell align="center">Receipt Status</StyledTableCell>
                    <StyledTableCell align="center">Bill Amount</StyledTableCell>
                    <StyledTableCell align="center">Paid Amount</StyledTableCell>
                    <StyledTableCell align="center">Balance Amount</StyledTableCell>
                    <StyledTableCell align="center">Approved By</StyledTableCell>
                    <StyledTableCell align="center">Updated By</StyledTableCell>
                    <StyledTableCell align="center" sx={{ position: 'sticky', right: 0, zIndex: 2 }}>
                      Actions
                    </StyledTableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {(rowsPerPage > 0
                    ? tableData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    : tableData
                  ).map((data, i) => (
                    <>
                      <TableRow key={`${data.customerId}${data.orderNo}${data.orderId}`} hover>
                        <TableCell align="center">{page * rowsPerPage + (i + 1)}</TableCell>
                        <TableCell align="center">{data.orderNo || '-'}
                          {data.IsDraft === 'Y' && (
                              <div style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '4px',
                                padding: '3px 7px',
                                borderRadius: '12px',
                                backgroundColor: '#e3f2fd',
                                border: '1px solid #90caf9'
                              }}>
                                <span style={{ fontSize: '14px', color: '#1976d2' }}>📝</span>
                                <span style={{
                                  color: '#1565c0',
                                  fontWeight: '600',
                                  fontSize: '0.75rem'
                                }}>
                                  Draft
                                </span>
                              </div>
                            )}
                        </TableCell>
                        <TableCell align="left" sx={{ whiteSpace: 'nowrap' }}>
                          {moment(data.orderDate).format('DD/MM/YYYY') || '-'}
                        </TableCell>
                        <TableCell align="left" sx={{ whiteSpace: 'nowrap' }}>
                          <Stack spacing={1} py={1}>
                            <Stack direction="row" spacing={1} alignItems="center">
                              <PortraitIcon fontSize="x-small" color="primary" />
                              <Typography variant="body2" pr={1}>
                                {data.customerName || '-'}
                              </Typography>{' '}
                              {data.hasNewItem === 'Y' && (
                                <Chip
                                  label="new goods"
                                  size="small"
                                  variant="outlined"
                                  color="success"
                                  sx={{
                                    boxShadow: '0 0 4px #A8CD89, 0 0 4px #A8CD89',
                                    animation: 'glow 1.5s infinite',
                                    '@keyframes glow': {
                                      '0%': { boxShadow: '0 0 4px #A8CD89, 0 0 4px #A8CD89' },
                                      '50%': { boxShadow: '0 0 4px #EBEAFF, 0 0 6px #EBEAFF' },
                                      '100%': { boxShadow: '0 0 4px #A8CD89, 0 0 4px #A8CD89' },
                                    },
                                  }}
                                />
                              )}
                              {Number(data.complaintId) !== 0 && (
                                <Chip
                                  label="complaints received"
                                  size="small"
                                  variant="outlined"
                                  color="warning"
                                  sx={{
                                    boxShadow: '0 0 4px #A8CD89, 0 0 4px #A8CD89',
                                    animation: 'glow 1.5s infinite',
                                    transition: 'transform 0.3s ease', // smooth zoom transition
                                    '@keyframes glow': {
                                      '0%': { boxShadow: '0 0 4px #A8CD89, 0 0 4px #A8CD89' },
                                      '50%': { boxShadow: '0 0 4px #EBEAFF, 0 0 6px #EBEAFF' },
                                      '100%': { boxShadow: '0 0 4px #A8CD89, 0 0 4px #A8CD89' },
                                    },
                                    '&:hover': {
                                      transform: 'scale(1.05)', // slight zoom
                                    },
                                  }}
                                />
                              )}
                            </Stack>
                            <Stack direction="row" spacing={1} alignItems="center">
                              <Phone fontSize="x-small" color="success" />
                              <Typography variant="body2" mr={2} pr={1}>
                                {data.phone || '-'}
                              </Typography>{' '}
                              | <Email fontSize="x-small" color="error" />
                              <Typography variant="body2" pr={1} sx={{ textTransform: 'lowercase' }}>
                                {data.emailId || '-'}
                              </Typography>
                            </Stack>{' '}
                          </Stack>
                        </TableCell>
                        <TableCell align="center">{data.Branch_Name || '-'}</TableCell>
                        <TableCell align="center">{data.PrimarySEName || '-'}</TableCell>
                        <TableCell align="center">{data.SecondarySEName || '-'}</TableCell>
                        <TableCell align="center">
                          {' '}
                          {(data.shipmentType === 'Courier' ? 'Air-Cargo' : 'Sea-Cargo') || '-'}
                        </TableCell>
                        <TableCell align="center">{data.SenderCountryName || '-'}</TableCell>
                        <TableCell align="center">{data.ReceiverCountryName || '-'}</TableCell>
                        <TableCell align="center">{data.gross_weight || '-'}</TableCell>
                        <TableCell align="center">{data.NO_OF_BOXES || '-'}</TableCell>
                        {/* <TableCell align="center">
                          {data.isCancel === 'Y' ? (
                            <Chip label="Cancelled" size="small" color="error" />
                          ) : data.OrderRaised === 'Y' ? (
                            <Chip label="Booking Confirmed" size="small" color="info" />
                          ) : data.approvalStatus === 'Y' ? (
                            <Chip label="Approved" size="small" color="success" />
                          ) : data.SE_OrderCancelReq === 'R' ? (
                            <Chip label="Cancel Requested" size="small" variant="outlined" color="error" />
                          ) : (
                            <Chip label="Pending" size="small" color="warning" />
                          )}
                        </TableCell> */}
                        <TableCell align="center">
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' }}>
                          {data.singleOrderStatus === 'Cancelled' ? (
                            <Chip label={data.singleOrderStatus} size="small" color="error" />
                          ) : data.singleOrderStatus === 'Bill Raised' ||
                            data.singleOrderStatus === 'Payment Received' ||
                            data.singleOrderStatus === 'Booking Confirmed' ||
                            data.singleOrderStatus === 'Part Payment' ? (
                            <Chip label={data.singleOrderStatus} size="small" color="info" />
                          ) : data.singleOrderStatus === 'Approved' ? (
                            <Chip label={data.singleOrderStatus} size="small" color="success" />
                          ) : data.singleOrderStatus === 'Cancel Requested' ? (
                            <Chip label={data.singleOrderStatus} size="small" variant="outlined" color="error" />
                          ) : (
                            <Chip label={data.singleOrderStatus} size="small" color="warning" />
                          )}

                                                                                      {data.TrackNo && (
                              <Button
                                variant="outlined"
                                size="small"
                                className='track_button'
                                startIcon={<LocalShippingIcon />}
                                onClick={() => {
                                window.open(`${axios.defaults.TRACKING_URL}${sessionStorage.getItem('country')}/${data.TrackNo}`, "_blank")
                                         }}
                                sx={{
                                  '& .MuiButton-startIcon': {
                                    animation: 'moveTruck 2s ease-in-out infinite',
                                    '@keyframes moveTruck': {
                                      '0%, 100%': {
                                        transform: 'translateX(0)',
                                      },
                                      '50%': {
                                        transform: 'translateX(5px)',
                                      },
                                    },
                                  },
                                  '&:hover': {
                                    '& .MuiButton-startIcon': {
                                      animation: 'bounce 0.5s ease infinite',
                                      '@keyframes bounce': {
                                        '0%, 100%': {
                                          transform: 'translateY(0)',
                                        },
                                        '50%': {
                                          transform: 'translateY(-2px)',
                                        },
                                      },
                                    },
                                  },
                                  
                                }}
                              >
                                Track
                              </Button>
                            )}
                                </div>
                        </TableCell>

                        <TableCell align="center">
                          {data.OrderStatus === 'Yes' ? (
                            <Chip label="Yes" size="small" color="success" />
                          ) : (
                            <Chip label="No" size="small" color="warning" />
                          )}
                        </TableCell>
                        <TableCell align="center">
                          {data.BillStatus === 'Yes' ? (
                            <Chip label="Yes" size="small" color="success" />
                          ) : (
                            <Chip label="No" size="small" color="warning" />
                          )}
                        </TableCell>
                        <TableCell align="center">
                          {data.ReceiptStatus === 'Yes' ? (
                            <Chip label="Yes" size="small" color="success" />
                          ) : (
                            <Chip label="No" size="small" color="warning" />
                          )}
                        </TableCell>

                        {/* <TableCell align="center">{data.salesExecutives || '-'}</TableCell> */}
                        <TableCell align="center">{numeral(data.BillAmt).format('0,0.00') || numeral(0).format('0,0.00')}</TableCell>
                        <TableCell align="center">{numeral(data.PaidAmount).format('0,0.00') || numeral(0).format('0,0.00')}</TableCell>
                        <TableCell align="center">{numeral(data.BalAmt).format('0,0.00') || numeral(0).format('0,0.00')}</TableCell>
                        <TableCell align="center">{data.ApprovedByName || '-'}</TableCell>
                        <TableCell align="center">{data.UpdatedByName || '-'}</TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            position: { xs: 'static', md: 'sticky' },
                            right: { xs: 0, md: 0 },
                            bgcolor: { xs: 'inherit', md: '#F9FAFB' },
                            zIndex: { xs: 'auto', md: 1 },
                            backdropFilter: 'blur(20px)',
                            transition: 'all 0.2s ease'
                          }}
                        >
                          <Stack direction="column" spacing={1} justifyContent="center" alignItems="center">
                            {/* <Stack direction="row" spacing={1} justifyContent="center" alignItems="center" sx={{width:'100%'}}> */}
                            <Button
                              variant={
                                 data.IsDraft === 'Y' ? 'contained' :
                                data.approvalStatus === 'N' && data.isCancel === 'N'
                                  ? data.SE_OrderCancelReq === 'R'
                                    ? 'contained'
                                    : 'contained'
                                  : 'outlined'
                              }
                              color={
                                data.IsDraft === 'Y' ? 'info' :
                                data.approvalStatus === 'N' && data.isCancel === 'N'
                                  ? data.SE_OrderCancelReq === 'R'
                                    ? 'warning'
                                    : 'success'
                                  : 'info'
                              }
                              sx={{ boxShadow: 1 }}
                              onClick={() => handleReviewButtonClick(data)}
                              size="small"
                              fullWidth
                              startIcon={
                                data.IsDraft === 'Y' ?  <EditNoteIcon fontSize="small" /> :
                                data.approvalStatus === 'N' && data.isCancel === 'N' ? (
                                  data.SE_OrderCancelReq === 'R' ? (
                                    <PreviewIcon fontSize="small" />
                                  ) : (
                                    <VerifiedIcon fontSize="small" />
                                  )
                                ) : (
                                  <PreviewIcon fontSize="small" />
                                )
                              }
                            >

                              { data.IsDraft === 'Y' ? 'Continue' :
                              (data.hasNewItem === 'Y' && data.Status === 'Y' && data.approvalStatus === 'N') ||
                                data.OrderRaised === 'Y'
                                ? data.approvalStatus === 'N' ? 'Approve' : 'View'
                                : data.approvalStatus === 'N' && data.isCancel === 'N'
                                  ? data.SE_OrderCancelReq === 'R'
                                    ? 'Review'
                                    : 'Approve'
                                  : 'View'}
                            </Button>
                            <Button
                              variant="contained"
                              color="primary"
                              sx={{ boxShadow: 1, whiteSpace: 'nowrap' }} // Corrected whiteSpace
                              onClick={() => handleFollowUpTableToggle(i, data)}
                              size="small"
                              fullWidth
                              startIcon={<EventRepeatIcon fontSize="small" />}
                            >
                              Follow-ups
                            </Button>
                            {/* </Stack> */}
                            {Number(data.ManifestId) !== 0 &&
                              <Button
                                variant="outlined"
                                color="error"
                                sx={{ boxShadow: 1, whiteSpace: 'nowrap' }}
                                onClick={() => {
                                  openComplaintDialog(data);
                                }}
                                size="small"
                                fullWidth
                                startIcon={<ReportGmailerrorredIcon fontSize="small" />}
                              >
                                {Number(data.complaintId) === 0 ? 'Register Complaint' : 'View Complaint'}
                              </Button>
                            }
                          </Stack>
                        </TableCell>
                        {/* <TableCell align="center">
                          <Stack direction="row" spacing={1}>
                            <Button
                              variant="contained"
                              size="small"
                              sx={{ backgroundColor: '#4CAF50', color: 'white' }}
                              onClick={() => handleReviewButtonClick(data)}
                            >
                              Review
                            </Button>
                            <Button
                              variant="outlined"
                              size="small"
                              sx={{ borderColor: '#03A9F4', color: '#03A9F4' }}
                              onClick={() => handleFollowUpTableToggle(data)}
                            >
                              View
                            </Button>
                            <Button
                              variant="outlined"
                              size="small"
                              sx={{ borderColor: '#FF0000', color: '#FF0000' }}
                              onClick={() => handleFollowUpTableToggle(data)}
                            >
                              Complaint
                            </Button>
                          </Stack>
                        </TableCell> */}
                      </TableRow>
                    </>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={totalRows}
              rowsPerPage={rowsPerPage}
              page={currentPage}
              onPageChange={(event, newPage) => setPage(newPage)}
              onRowsPerPageChange={(event) => {
                setRowsPerPage(parseInt(event.target.value, 10));
                setPage(0);
              }}
              mt={2}
            />
          </>
        </Collapse>
        {tableData.length === 0 && <NoResultsFound />}
        {/* Dialog to display review content */}
        <Dialog fullScreen open={isDialogOpen} onClose={closeDialog}>
          <DialogTitle>
            <Typography
              variant="h5"
              p={1}
              boxShadow={1}
              borderColor="#11235A"
              textAlign={'center'}
              borderRadius={8}
              color="white"
              sx={{
                background:
                  currentOrderDetails?.shipmentType === 'Courier'
                    ? 'linear-gradient(to right, #667db6, #0082c8, #0082c8, #667db6)'
                    : 'linear-gradient(to right, #4ecdc4, #556270)',
                boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
              }}
            >
              <Typography variant="h6" color="white" className="font_style1" textAlign={'center'}>
                {currentOrderDetails?.shipmentType} - Order Preview for Order No {currentOrderDetails?.orderNo}
              </Typography>
            </Typography>
          </DialogTitle>
          <DialogContent>
            {currentOrderDetails &&
              (currentOrderDetails?.shipmentType === 'Courier' ? (
                <PreviewForCourierOrderApproval
                  setDialogOpenState={setDialogOpenState}
                  orderDetails={currentOrderDetails}
                  getAllData={getAllData}
                  formType={'Edit'}
                  shipType={''}
                />
              ) : (
                <PreviewForCargoOrderApproval
                  setDialogOpenState={setDialogOpenState}
                  orderDetails={currentOrderDetails}
                  getAllData={getAllData}
                  formType={'Edit'}
                  shipType={''}
                />
              ))}
          </DialogContent>
        </Dialog>

        {/* Dialog for follow-up table */}
        <Dialog open={openFollowUpTable} maxWidth={'xl'} fullScreen={smallScreen} fullWidth>
          <DialogContent>
            <Divider sx={{ mt: 2 }}>
              <Chip
                label={`Follow-Ups on ${rowData?.shipmentType} : Order No.  ${rowData?.orderNo}`}
                size="small"
                color="primary"
                variant="outlined"
              />
            </Divider>
            <Grid container spacing={2} mb={1}>
              {!smallScreen && (
                <Grid item md={9} xs={12}>
                  <Stack spacing={1}>
                    <Stack direction="row" spacing={1} alignItems="center">
                      <PortraitIcon fontSize="x-small" color="primary" />
                      <Typography variant="subtitle2" color="#243642" pr={1}>
                        {rowData?.customerName || '-'}{' '}
                      </Typography>{' '}
                    </Stack>
                    <Stack direction="row" spacing={1} alignItems="center">
                      <Phone fontSize="x-small" color="success" />
                      <Typography variant="body2" mr={2} pr={1}>
                        {rowData?.phone || '-'}
                      </Typography>{' '}
                      | <Email fontSize="x-small" color="error" />
                      <Typography variant="body2" pr={1} sx={{ textTransform: 'lowercase' }}>
                        {rowData?.emailId || '-'}
                      </Typography>
                    </Stack>{' '}
                  </Stack>
                </Grid>
              )}
            </Grid>
            <TableContainer component={Paper} elevation={2} sx={{ bgcolor: 'inherit' }}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <StyledTableCell2 align="center">S.No</StyledTableCell2>
                    <StyledTableCell2 align="center">Follow-up Date & Time </StyledTableCell2>
                    <StyledTableCell2 align="left">Remarks</StyledTableCell2>
                    <StyledTableCell2 align="center">Created Date & Time </StyledTableCell2>
                    <StyledTableCell2 align="center">Created By</StyledTableCell2>
                    {/* {moment(rowData?.ExpiryDate).format('YYYYMMDD') === '19000101' &&
                      <StyledTableCell2 align="center">Actions</StyledTableCell2>
                    } */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {oneCustomerFollowUps.map((followUp, index) => (
                    <TableRow key={index}>
                      <TableCell align="center">{index + 1}</TableCell>
                      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
                        {moment.utc(followUp.followupDate).format('LLL')}
                      </TableCell>
                      {/* <TableCell align="left">{followUp.remarks}</TableCell> */}
                      <TableCell align="left">
                        {followUp.followup !== 'Follow Up'
                          ? <>
                            <Chip label={'Cancel Remarks :'} size="small" color="error" sx={{ mr: 1 }} />
                            {followUp.remarks}
                          </>
                          : followUp.remarks}
                      </TableCell>
                      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
                        {moment(followUp.createdOn).format('LLL')}
                      </TableCell>
                      <TableCell align="center">{followUp.CreatedUser}</TableCell>
                      {/* {moment(rowData?.ExpiryDate).format('YYYYMMDD') === '19000101' &&
                        <TableCell align="center" sx={{ padding: '0' }}>
                          <IconButton aria-label="Edit" onClick={() => handleEditFollowUp(followUp)}>
                            <EditIcon color="primary" />
                          </IconButton>
                          <IconButton aria-label="Delete" onClick={() => handleOpenConfirmDialog(followUp.timelineId)}>
                            <DeleteForeverIcon color="error" />
                          </IconButton>
                        </TableCell>
                      } */}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Stack direction="row" spacing={1} justifyContent="center" alignItems="center" mt={2}>
              <Button
                onClick={() => {
                  setOpenFollowUpTable(null);
                  SetRowData(null);
                }}
                color="warning"
                variant="contained"
                size="small"
              >
                Close
              </Button>
            </Stack>
          </DialogContent>
        </Dialog>

        {/* Add Complaint Popup */}
        <Dialog fullWidth maxWidth={'md'} open={isComplaintDialogOpen} onClose={closeComplaintDialog}>
          <DialogContent>
            <ComplaintAdd
              setComplaintDialogOpenState={setComplaintDialogOpenState}
              complaintDetail={complaintDetail}
              getAllData={getAllData}
            />
          </DialogContent>
        </Dialog>
      </Container>
    </>
  );
};

export default BookingApproval;
